const {Component} = require("react");
const PropTypes = require("prop-types");

class ColorSelector extends Component {

	static get propTypes() {
		return {
			title: PropTypes.string,
			options: PropTypes.any.isRequired,
			onChange: PropTypes.func
		};
	}

	static get defaultProps() {
		return {
			title: translate("Farvenuance")
		};
	}

	get value() {
		return this.selectElement.value;
	}

	get defaultValue() {
		return this.props.options.length > 0 ? this.props.options[0] : "";
	}

	reset() {
		this.selectElement.value = this.props.options[0];
	}

	_onChange = () => {
		if (typeof this.props.onChange === "function") {
			return this.props.onChange(this.value);
		}
	};

	renderOptions() {
		let colors = [];
		for (let key in this.props.options) {
			const colorObj = this.props.options[key];
			colors.push(<option key={colorObj} value={key}>{colorObj}</option>)
			
		}
		return colors;
	}

	render() {
		return (
			<div className="color-selector">
				<label htmlFor="productColorSelector">{this.props.title}</label>
				<select id="productColorSelector" ref={el => this.selectElement = el}
								onChange={this._onChange} defaultValue={this.defaultValue}>{this.renderOptions()}</select>
			</div>
		);
	}

}

module.exports = ColorSelector;
